export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ModalNuovaTarga.vue?vue&type=template&id=72c2deda&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./modules/Home/views/src/components/ModalNuovaTarga.vue?vue&type=template&id=72c2deda&scoped=true&
// module id = 754
// module chunks = 0